import { InjectionToken, PLATFORM_ID, Input, Output, EventEmitter, Directive, NgZone, ElementRef, Optional, Inject, KeyValueDiffers, Component, ViewChild, ViewEncapsulation, NgModule } from '@angular/core';
import * as Swiper from 'swiper/dist/js/swiper.js';
import { isPlatformBrowser, CommonModule } from '@angular/common';
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ SWIPER_CONFIG = new InjectionToken('SWIPER_CONFIG');
var /** @type {?} */ SwiperEvents = [
    'init',
    'beforeDestroy',
    'scroll',
    'progress',
    'keyPress',
    'beforeResize',
    'afterResize',
    'resize',
    'breakpoint',
    'beforeResize',
    'keyPress',
    'sliderMove',
    'slideChange',
    'setTranslate',
    'setTransition',
    'fromEdge',
    'reachEnd',
    'reachBeginning',
    'autoplay',
    'autoplayStop',
    'autoplayStart',
    'imagesReady',
    'lazyImageLoad',
    'lazyImageReady',
    'scrollDragEnd',
    'scrollDragMove',
    'scrollDragStart',
    'swiperTap',
    'swiperClick',
    'swiperDoubleTap',
    'swiperTouchEnd',
    'swiperTouchMove',
    'swiperTouchStart',
    'swiperTouchMoveOpposite',
    'swiperTransitionEnd',
    'swiperTransitionStart',
    'slideNextTransitionEnd',
    'slideNextTransitionStart',
    'slidePrevTransitionEnd',
    'slidePrevTransitionStart',
    'slideChangeTransitionEnd',
    'slideChangeTransitionStart'
];
var SwiperConfig = /*@__PURE__*/ (function () {
    function SwiperConfig(config) {
        if (config === void 0) {
            config = {};
        }
        this.assign(config);
    }
    /**
     * @param {?=} config
     * @param {?=} target
     * @return {?}
     */
    SwiperConfig.prototype.assign = /**
     * @param {?=} config
     * @param {?=} target
     * @return {?}
     */
        function (config, target) {
            if (config === void 0) {
                config = {};
            }
            target = target || this;
            for (var /** @type {?} */ key in config) {
                if (config[key] != null && !Array.isArray(config[key]) && typeof config[key] === 'object' &&
                    (typeof HTMLElement === 'undefined' || !(config[key] instanceof HTMLElement))) {
                    target[key] = {};
                    this.assign(config[key], target[key]);
                }
                else {
                    target[key] = config[key];
                }
            }
        };
    return SwiperConfig;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SwiperDirective = /*@__PURE__*/ (function () {
    function SwiperDirective(platformId, zone, elementRef, differs, defaults) {
        this.platformId = platformId;
        this.zone = zone;
        this.elementRef = elementRef;
        this.differs = differs;
        this.defaults = defaults;
        this.disabled = false;
        this.indexChange = new EventEmitter();
        this.S_INIT = new EventEmitter();
        this.S_BEFOREDESTROY = new EventEmitter();
        this.S_SCROLL = new EventEmitter();
        this.S_PROGRESS = new EventEmitter();
        this.S_RESIZE = new EventEmitter();
        this.S_BREAKPOINT = new EventEmitter();
        this.S_BEFORERESIZE = new EventEmitter();
        this.S_KEYPRESS = new EventEmitter();
        this.S_SLIDERMOVE = new EventEmitter();
        this.S_SLIDECHANGE = new EventEmitter();
        this.S_SETTRANSLATE = new EventEmitter();
        this.S_SETTRANSITION = new EventEmitter();
        this.S_FROMEDGE = new EventEmitter();
        this.S_REACHEND = new EventEmitter();
        this.S_REACHBEGINNING = new EventEmitter();
        this.S_AUTOPLAY = new EventEmitter();
        this.S_AUTOPLAYSTART = new EventEmitter();
        this.S_AUTOPLAYSTOP = new EventEmitter();
        this.S_IMAGESREADY = new EventEmitter();
        this.S_LAZYIMAGELOAD = new EventEmitter();
        this.S_LAZYIMAGEREADY = new EventEmitter();
        this.S_SCROLLDRAGEND = new EventEmitter();
        this.S_SCROLLDRAGMOVE = new EventEmitter();
        this.S_SCROLLDRAGSTART = new EventEmitter();
        this.S_TAP = new EventEmitter();
        this.S_CLICK = new EventEmitter();
        this.S_DOUBLETAP = new EventEmitter();
        this.S_TOUCHEND = new EventEmitter();
        this.S_TOUCHMOVE = new EventEmitter();
        this.S_TOUCHSTART = new EventEmitter();
        this.S_TOUCHMOVEOPPOSITE = new EventEmitter();
        this.S_TRANSITIONEND = new EventEmitter();
        this.S_TRANSITIONSTART = new EventEmitter();
        this.S_SLIDEPREVTRANSITIONEND = new EventEmitter();
        this.S_SLIDEPREVTRANSITIONSTART = new EventEmitter();
        this.S_SLIDENEXTTRANSITIONEND = new EventEmitter();
        this.S_SLIDENEXTTRANSITIONSTART = new EventEmitter();
        this.S_SLIDECHANGETRANSITIONEND = new EventEmitter();
        this.S_SLIDECHANGETRANSITIONSTART = new EventEmitter();
    }
    Object.defineProperty(SwiperDirective.prototype, "index", {
        set: /**
         * @param {?} index
         * @return {?}
         */ function (index) {
            if (index != null) {
                this.setIndex(index);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SwiperDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
        function () {
            var _this = this;
            if (!isPlatformBrowser(this.platformId)) {
                return;
            }
            var /** @type {?} */ params = new SwiperConfig(this.defaults);
            params.assign(this.config); // Custom configuration
            if (params.scrollbar === true) {
                params.scrollbar = {
                    el: '.swiper-scrollbar'
                };
            }
            if (params.pagination === true) {
                params.pagination = {
                    el: '.swiper-pagination'
                };
            }
            if (params.navigation === true) {
                params.navigation = {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next'
                };
            }
            if (this.disabled) {
                params.allowSlidePrev = false;
                params.allowSlideNext = false;
            }
            if (this.initialIndex != null) {
                params.initialSlide = this.initialIndex;
                this.initialIndex = null;
            }
            params['on'] = {
                slideChange: function () {
                    _this.zone.run(function () {
                        if (_this.instance) {
                            _this.indexChange.emit(_this.instance.realIndex);
                        }
                    });
                }
            };
            this.zone.runOutsideAngular(function () {
                _this.instance = new Swiper(_this.elementRef.nativeElement, params);
            });
            if (params.init !== false) {
                this.S_INIT.emit(this.instance);
            }
            // Add native Swiper event handling
            SwiperEvents.forEach(function (eventName) {
                eventName = eventName.replace('swiper', '');
                eventName = eventName.charAt(0).toLowerCase() + eventName.slice(1);
                _this.instance.on(eventName, function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (args.length === 1) {
                        args = args[0];
                    }
                    if (_this["S_" + eventName.toUpperCase()]) {
                        _this.zone.run(function () {
                            _this["S_" + eventName.toUpperCase()].emit(args);
                        });
                    }
                });
            });
            if (!this.configDiff) {
                this.configDiff = this.differs.find(this.config || {}).create();
                this.configDiff.diff(this.config || {});
            }
        };
    /**
     * @return {?}
     */
    SwiperDirective.prototype.ngDoCheck = /**
     * @return {?}
     */
        function () {
            if (this.configDiff) {
                var /** @type {?} */ changes = this.configDiff.diff(this.config || {});
                if (changes) {
                    this.initialIndex = this.getIndex(true);
                    this.ngOnDestroy();
                    this.ngAfterViewInit();
                    this.update();
                }
            }
        };
    /**
     * @return {?}
     */
    SwiperDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            var _this = this;
            if (this.instance) {
                this.zone.runOutsideAngular(function () {
                    _this.instance.destroy(true, _this.instance.initialized || false);
                });
                this.instance = null;
            }
        };
    /**
     * @param {?} changes
     * @return {?}
     */
    SwiperDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
        function (changes) {
            var _this = this;
            if (this.instance && changes['disabled']) {
                if (changes['disabled'].currentValue !== changes['disabled'].previousValue) {
                    if (changes['disabled'].currentValue === true) {
                        this.zone.runOutsideAngular(function () {
                            _this.ngOnDestroy();
                            _this.ngAfterViewInit();
                        });
                    }
                    else if (changes['disabled'].currentValue === false) {
                        this.zone.runOutsideAngular(function () {
                            _this.ngOnDestroy();
                            _this.ngAfterViewInit();
                        });
                    }
                }
            }
        };
    /**
     * @return {?}
     */
    SwiperDirective.prototype.swiper = /**
     * @return {?}
     */
        function () {
            return this.instance;
        };
    /**
     * @return {?}
     */
    SwiperDirective.prototype.init = /**
     * @return {?}
     */
        function () {
            var _this = this;
            if (this.instance) {
                this.zone.runOutsideAngular(function () {
                    _this.instance.init();
                });
            }
        };
    /**
     * @return {?}
     */
    SwiperDirective.prototype.update = /**
     * @return {?}
     */
        function () {
            var _this = this;
            setTimeout(function () {
                if (_this.instance) {
                    _this.zone.runOutsideAngular(function () {
                        _this.instance.update();
                    });
                }
            }, 0);
        };
    /**
     * @param {?=} real
     * @return {?}
     */
    SwiperDirective.prototype.getIndex = /**
     * @param {?=} real
     * @return {?}
     */
        function (real) {
            if (!this.instance) {
                return this.initialIndex;
            }
            else {
                return real ? this.instance.realIndex : this.instance.activeIndex;
            }
        };
    /**
     * @param {?} index
     * @param {?=} speed
     * @param {?=} silent
     * @return {?}
     */
    SwiperDirective.prototype.setIndex = /**
     * @param {?} index
     * @param {?=} speed
     * @param {?=} silent
     * @return {?}
     */
        function (index, speed, silent) {
            var _this = this;
            if (!this.instance) {
                this.initialIndex = index;
            }
            else {
                var /** @type {?} */ realIndex_1 = index * this.instance.params.slidesPerGroup;
                if (this.instance.params.loop) {
                    realIndex_1 += this.instance.loopedSlides;
                }
                this.zone.runOutsideAngular(function () {
                    _this.instance.slideTo(realIndex_1, speed, !silent);
                });
            }
        };
    /**
     * @param {?=} speed
     * @param {?=} silent
     * @return {?}
     */
    SwiperDirective.prototype.prevSlide = /**
     * @param {?=} speed
     * @param {?=} silent
     * @return {?}
     */
        function (speed, silent) {
            var _this = this;
            if (this.instance) {
                this.zone.runOutsideAngular(function () {
                    _this.instance.slidePrev(speed, !silent);
                });
            }
        };
    /**
     * @param {?=} speed
     * @param {?=} silent
     * @return {?}
     */
    SwiperDirective.prototype.nextSlide = /**
     * @param {?=} speed
     * @param {?=} silent
     * @return {?}
     */
        function (speed, silent) {
            var _this = this;
            if (this.instance) {
                this.zone.runOutsideAngular(function () {
                    _this.instance.slideNext(speed, !silent);
                });
            }
        };
    /**
     * @param {?=} reset
     * @return {?}
     */
    SwiperDirective.prototype.stopAutoplay = /**
     * @param {?=} reset
     * @return {?}
     */
        function (reset) {
            var _this = this;
            if (reset) {
                this.setIndex(0);
            }
            if (this.instance && this.instance.autoplay) {
                this.zone.runOutsideAngular(function () {
                    _this.instance.autoplay.stop();
                });
            }
        };
    /**
     * @param {?=} reset
     * @return {?}
     */
    SwiperDirective.prototype.startAutoplay = /**
     * @param {?=} reset
     * @return {?}
     */
        function (reset) {
            var _this = this;
            if (reset) {
                this.setIndex(0);
            }
            if (this.instance && this.instance.autoplay) {
                this.zone.runOutsideAngular(function () {
                    _this.instance.autoplay.start();
                });
            }
        };
    return SwiperDirective;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SwiperComponent = /*@__PURE__*/ (function () {
    function SwiperComponent(platformId, zone, defaults) {
        this.platformId = platformId;
        this.zone = zone;
        this.defaults = defaults;
        this.index = null;
        this.disabled = false;
        this.useSwiperClass = true;
        this.indexChange = new EventEmitter();
        this.S_INIT = new EventEmitter();
        this.S_BEFOREDESTROY = new EventEmitter();
        this.S_SCROLL = new EventEmitter();
        this.S_PROGRESS = new EventEmitter();
        this.S_RESIZE = new EventEmitter();
        this.S_BREAKPOINT = new EventEmitter();
        this.S_BEFORERESIZE = new EventEmitter();
        this.S_KEYPRESS = new EventEmitter();
        this.S_SLIDERMOVE = new EventEmitter();
        this.S_SLIDECHANGE = new EventEmitter();
        this.S_SETTRANSLATE = new EventEmitter();
        this.S_SETTRANSITION = new EventEmitter();
        this.S_FROMEDGE = new EventEmitter();
        this.S_REACHEND = new EventEmitter();
        this.S_REACHBEGINNING = new EventEmitter();
        this.S_AUTOPLAY = new EventEmitter();
        this.S_AUTOPLAYSTART = new EventEmitter();
        this.S_AUTOPLAYSTOP = new EventEmitter();
        this.S_IMAGESREADY = new EventEmitter();
        this.S_LAZYIMAGELOAD = new EventEmitter();
        this.S_LAZYIMAGEREADY = new EventEmitter();
        this.S_SCROLLDRAGEND = new EventEmitter();
        this.S_SCROLLDRAGMOVE = new EventEmitter();
        this.S_SCROLLDRAGSTART = new EventEmitter();
        this.S_TAP = new EventEmitter();
        this.S_CLICK = new EventEmitter();
        this.S_DOUBLETAP = new EventEmitter();
        this.S_TOUCHEND = new EventEmitter();
        this.S_TOUCHMOVE = new EventEmitter();
        this.S_TOUCHSTART = new EventEmitter();
        this.S_TOUCHMOVEOPPOSITE = new EventEmitter();
        this.S_TRANSITIONEND = new EventEmitter();
        this.S_TRANSITIONSTART = new EventEmitter();
        this.S_SLIDEPREVTRANSITIONEND = new EventEmitter();
        this.S_SLIDEPREVTRANSITIONSTART = new EventEmitter();
        this.S_SLIDENEXTTRANSITIONEND = new EventEmitter();
        this.S_SLIDENEXTTRANSITIONSTART = new EventEmitter();
        this.S_SLIDECHANGETRANSITIONEND = new EventEmitter();
        this.S_SLIDECHANGETRANSITIONSTART = new EventEmitter();
    }
    Object.defineProperty(SwiperComponent.prototype, "isAtLast", {
        get: /**
         * @return {?}
         */ function () {
            return (!this.directiveRef || !this.directiveRef.swiper) ?
                false : this.directiveRef.swiper['isEnd'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwiperComponent.prototype, "isAtFirst", {
        get: /**
         * @return {?}
         */ function () {
            return (!this.directiveRef || !this.directiveRef.swiper) ?
                false : this.directiveRef.swiper['isBeginning'];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SwiperComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
        function () {
            var _this = this;
            if (!isPlatformBrowser(this.platformId)) {
                return;
            }
            this.zone.runOutsideAngular(function () {
                _this.updateClasses();
                if (typeof MutationObserver !== 'undefined') {
                    _this.mo = new MutationObserver(function (mutations) {
                        _this.updateClasses();
                    });
                    _this.mo.observe(_this.swiperSlides.nativeElement, { childList: true });
                }
            });
        };
    /**
     * @return {?}
     */
    SwiperComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            if (this.mo) {
                this.mo.disconnect();
            }
            if (this.config && this.paginationBackup) {
                this.config.pagination = this.paginationBackup;
            }
        };
    /**
     * @return {?}
     */
    SwiperComponent.prototype.getConfig = /**
     * @return {?}
     */
        function () {
            var _this = this;
            this.swiperConfig = new SwiperConfig(this.defaults);
            this.swiperConfig.assign(this.config); // Custom configuration
            if (this.swiperConfig.pagination === true ||
                (this.swiperConfig.pagination && typeof this.swiperConfig.pagination === 'object' &&
                    (!this.swiperConfig.pagination.type || this.swiperConfig.pagination.type === 'bullets') &&
                    !this.swiperConfig.pagination.renderBullet && this.swiperConfig.pagination.el === '.swiper-pagination')) {
                this.config = this.config || {};
                if (!this.paginationConfig) {
                    this.paginationBackup = this.config.pagination;
                    this.paginationConfig = {
                        el: '.swiper-pagination',
                        renderBullet: function (index, className) {
                            var /** @type {?} */ children = _this.swiperSlides.nativeElement.children;
                            var /** @type {?} */ bullet = "<span class=\"" + className + " " + className + "-middle\" index=\"" + index + "\"></span>";
                            if (index === 0) {
                                bullet = "<span class=\"" + className + " " + className + "-first\" index=\"" + index + "\"></span>";
                            }
                            else if (index === (children.length - 1)) {
                                bullet = "<span class=\"" + className + " " + className + "-last\" index=\"" + index + "\"></span>";
                            }
                            return "<span class=\"swiper-pagination-handle\" index=\"" + index + "\">" + bullet + "</span>";
                        }
                    };
                }
                if (this.swiperConfig.pagination === true) {
                    this.config.pagination = this.paginationConfig;
                }
                else {
                    this.config.pagination = Object.assign({}, this.config.pagination, this.paginationConfig);
                }
            }
            return this.config;
        };
    /**
     * @return {?}
     */
    SwiperComponent.prototype.updateClasses = /**
     * @return {?}
     */
        function () {
            var /** @type {?} */ updateNeeded = false;
            var /** @type {?} */ children = this.swiperSlides.nativeElement.children;
            for (var /** @type {?} */ i = 0; i < children.length; i++) {
                if (!children[i].classList.contains('swiper-slide')) {
                    updateNeeded = true;
                    children[i].classList.add('swiper-slide');
                }
            }
            if (updateNeeded) {
                this.directiveRef.update();
            }
        };
    return SwiperComponent;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SwiperModule = /*@__PURE__*/ (function () {
    function SwiperModule() {
    }
    return SwiperModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export { SwiperComponent, SwiperDirective, SWIPER_CONFIG, SwiperConfig, SwiperModule };
//# sourceMappingURL=ngx-swiper-wrapper.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-swiper-wrapper/dist/ngx-swiper-wrapper.es5.js
// module id = null
// module chunks = 